import Preload from '../components/Preload'
import Canvas from '../components/Canvas'


import React, { Component, PropTypes } from 'react'
// import { SHOW_ALL, SHOW_COMPLETED, SHOW_ACTIVE } from '../constants/TodoFilters'

// const TODO_FILTERS = {
//   [SHOW_ALL]: () => true,
//   [SHOW_ACTIVE]: todo => !todo.completed,
//   [SHOW_COMPLETED]: todo => todo.completed
// }

export default class MainSection extends Component {
  
  render() {
    const { canvas, actions } = this.props;
    
    // const { filter } = this.state
    //
    // const filteredTodos = todos.filter(TODO_FILTERS[filter])
    // const completedCount = todos.reduce((count, todo) =>
    //   todo.completed ? count + 1 : count,
    //   0
    // )
    return (<div>
      {(() => {
        if (canvas.loadedAnimateccJS)
          return <Canvas actions={actions} canvas={canvas} />;
      })()}
      <Preload canvas={canvas} />
    </div>)
  }
  
  componentDidMount() {
    this.checkLoadAnimateccJS()
  }
  
  checkLoadAnimateccJS() {
    const { actions } = this.props;
    if(window.lib && window.lib.container) {
      actions.loadedAnimateccJS()
    }else {
      setTimeout(this.checkLoadAnimateccJS.bind(this), 1000)
    }
  }
  
}





/** WEBPACK FOOTER **
 ** ./src/components/MainSection.js
 **/